import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import ForChildren from "./pages/ForChildren";
import ForAdults from "./pages/ForAdults";
import Eligibility from "./pages/Eligibility";
import CostFunding from "./pages/CostFunding";
import Doctors from "./pages/Doctors";
import Technology from "./pages/Technology";
import ProductDetail from "./pages/ProductDetail";
import Rehabilitation from "./pages/Rehabilitation";
import PatientStories from "./pages/PatientStories";
import News from "./pages/News";
import NewsArticle from "./pages/NewsArticle";
import CSR from "./pages/CSR";
import KnowledgeCentre from "./pages/KnowledgeCentre";
import Article from "./pages/Article";
import Register from "./pages/Register";
import CityPage from "./pages/CityPage";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminContent from "./pages/admin/AdminContent";

function PublicLayout({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <Toaster richColors position="top-center" />
      <Routes>
        {/* Admin (no main layout) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
        <Route path="/admin/content" element={<AdminContent />} />

        {/* Public */}
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/about-cochlear-implants" element={<PublicLayout><About /></PublicLayout>} />
        <Route path="/child-cochlear-implant" element={<PublicLayout><ForChildren /></PublicLayout>} />
        <Route path="/adult-cochlear-implant" element={<PublicLayout><ForAdults /></PublicLayout>} />
        <Route path="/cochlear-implant-eligibility" element={<PublicLayout><Eligibility /></PublicLayout>} />
        <Route path="/cochlear-implant-cost-funding" element={<PublicLayout><CostFunding /></PublicLayout>} />
        <Route path="/doctors" element={<PublicLayout><Doctors /></PublicLayout>} />
        <Route path="/doctors/dr-sanjay-sachdeva" element={<PublicLayout><Doctors /></PublicLayout>} />
        <Route path="/technology" element={<PublicLayout><Technology /></PublicLayout>} />
        <Route path="/technology/:productId" element={<PublicLayout><ProductDetail /></PublicLayout>} />
        <Route path="/rehabilitation" element={<PublicLayout><Rehabilitation /></PublicLayout>} />
        <Route path="/patient-stories" element={<PublicLayout><PatientStories /></PublicLayout>} />
        <Route path="/news" element={<PublicLayout><News /></PublicLayout>} />
        <Route path="/news/:slug" element={<PublicLayout><NewsArticle /></PublicLayout>} />
        <Route path="/csr" element={<PublicLayout><CSR /></PublicLayout>} />
        <Route path="/knowledge-centre" element={<PublicLayout><KnowledgeCentre /></PublicLayout>} />
        <Route path="/article/:slug" element={<PublicLayout><Article /></PublicLayout>} />
        <Route path="/register" element={<PublicLayout><Register /></PublicLayout>} />
        <Route path="/city/:slug" element={<PublicLayout><CityPage /></PublicLayout>} />

        <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
